import { useMutation } from '@tanstack/react-query';
import { notifications } from '@mantine/notifications';
import { useTranslation } from 'react-i18next';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError.ts';
import { FacilityInvitationMessagesApi } from '../../../apis/InvitationApi/FacilityInvitationMessagesApi.ts';

interface SendTestInvitationVars {
    language: string;
    bodyHtml: string;
    facilityId?: number;
}

export function useSendTestInvitation() {
    const { t } = useTranslation();
    return useMutation<void, AppMedError, SendTestInvitationVars>({
        mutationKey: [QueryKeys.facilityInvitationMessages, 'sendTest'],
        mutationFn: ({ language, bodyHtml, facilityId }) =>
            FacilityInvitationMessagesApi.sendTestInvitation(language, bodyHtml, facilityId),
        onSuccess: () => {
            notifications.show({
                color: 'green',
                message: t('invitationMessage.admin.testEmailSent'),
            });
        },
        onError: (err) => {
            notifications.show({ color: 'red', message: err.message });
        },
    });
}
